
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/transactions",
      function () {
        return require("private-next-pages/user/transactions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/transactions"])
      });
    }
  